import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: var(--space-200);
`

export const ButtonWrapper = styled.div`
  & > a {
    text-underline-offset: var(--space-50);
    text-decoration-color: var(--text-secondary-invert);

    &:hover {
      text-decoration-color: inherit;
    }
  }
`
